module.exports = __webpack_public_path__ + "static/4-69d5d8f33be52049bee87e718884d9a6.png";